import { getLocale } from "../runtime";

const sv_pc = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `st`
};

const pc = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_pc(inputs)
	return "pc";
};

export { pc as "pc" };